import {
  useGetService,
  type UseGetServiceOptions,
} from "@libs/service-providers/api-service-provider";

import { COUNTRIES_URL } from "./apiEndpoints";
import type { CountryItem } from "./types";

type Params = {
  region?: string;
  status?: string;
  domain?: string;
  sort_by?: string;
  order?: string;
};

type Options = Omit<UseGetServiceOptions<CountryItem[]>, "route" | "queryKey"> & {
  params?: Params;
};

export const useGetCountries = (options?: Options) =>
  useGetService<CountryItem[]>({
    route: COUNTRIES_URL,
    queryKey: ["dq-dashboard", "countries", options?.params],
    config: { ...options?.config, params: options?.params },
    retry: false,
    ...(options ?? {}),
  });
